import script from "./AddCar.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__